export default "__VITE_ASSET__036ed6dd__"